import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=c889fef6&scoped=true"
import script from "./detailPage.vue?vue&type=script&lang=js"
export * from "./detailPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/introduce-common.scss?vue&type=style&index=0&id=c889fef6&prod&lang=scss&scoped=true&external"
import style1 from "./detailPage.vue?vue&type=style&index=1&id=c889fef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c889fef6",
  null
  
)

export default component.exports